// Orders.js
import React from 'react';
import './query.css';
import BodyVisual from './bodyvisual';
import QueryResults from './QueryResults';

function Query() {
  return (
    <div className='QueryBody'>
          <div className='QueryBodyLeft'> <BodyVisual>   </BodyVisual>    </div>
          <div className='QueryBodyRight'> <QueryResults /> </div>


    </div>
  );
}

export default Query;
